import { Injectable } from "@angular/core";
import { HttpClient, HttpResponse } from "@angular/common/http";
import { CreatePublicRoomRequest } from "../models/create-public-room.request";
import { Observable } from "rxjs";
import { StringResponse } from "@shared/models/string-response";
import { SignalMyRoomsResponse } from "@shared/models/signal-myRooms.response";
import {
  GetRoomMessagesRequest,
  GetRoomMessagesResponse,
  CreatePrivateChatRequest, GetRoomMissingMessagesRequest, ReactOnMessageRequest, SearchMessageInChatRequest, SearchInMessageHistoryResponse, UnreadMessageRequestPayload
} from "@shared/models/signalR-models";
import { ChatRoomParticipantModel } from "@shared/models/create-chat-lists.model";
import {GetSuggestedFriendsResponse} from "@shared/models/create-chat-lists.model";
import {UploadChatAttachmentRequest} from "../models/upload-chat-attachment.request";

@Injectable({
  providedIn: 'root'
})
export class RoomService {

  private get BaseUrl() {
    return '/rooms';
  };
  constructor(private httpClient: HttpClient) {
  }

  getChatRoomTeamMembers(): Observable<ChatRoomParticipantModel[]> {
    const url = this.BaseUrl+'/billing-users';
    return this.httpClient.get<ChatRoomParticipantModel[]>(url);
  }

  unreadMessage(requestPayload: UnreadMessageRequestPayload): Observable<any>{
    const url = this.BaseUrl + "/unread-message";
    return this.httpClient.put(url, requestPayload);
  }

  getSuggestedFriends(customerId? : string): Observable<GetSuggestedFriendsResponse[]> {
    const url = this.BaseUrl + '/suggested-friends' + `?customerId=${!!customerId ? customerId : null}`;
    return this.httpClient.get<GetSuggestedFriendsResponse[]>(url);
  }
  getAvailableParticipants(roomId : string): Observable<GetSuggestedFriendsResponse[]> {
    const url = this.BaseUrl + `/${roomId}/available-participants`;
    return this.httpClient.get<GetSuggestedFriendsResponse[]>(url);
  }
  getArchiveRooms(): Observable<SignalMyRoomsResponse []> {
    const url = this.BaseUrl + '/archived-rooms';
    return this.httpClient.get<SignalMyRoomsResponse []>(url);
  }

  searchMessage(requestPayload: SearchMessageInChatRequest):Observable<SearchInMessageHistoryResponse[]>{
    const url = this.BaseUrl + '/search-message';
    return this.httpClient.put<SearchInMessageHistoryResponse[]>(url,requestPayload);
  }

  getRoomMessages(request: GetRoomMessagesRequest): Observable<GetRoomMessagesResponse> {
    const url = this.BaseUrl + `/${request.roomId}/messages`;
    return this.httpClient.post<GetRoomMessagesResponse>(url, request);
  }

  getChatRoomCustomerUsers(
      customerId: string
  ): Observable<ChatRoomParticipantModel[]> {
    const url = this.BaseUrl +"/customers/" + customerId + "/users";
    return this.httpClient.get<ChatRoomParticipantModel[]>(url);
  }

  createInternalRoom(request: CreatePublicRoomRequest): Observable<StringResponse> {
    const url = this.BaseUrl + '/create-public';
    return  this.httpClient.post<StringResponse>(url, request)
  }

  createPrivateRoom(request: CreatePrivateChatRequest): Observable<SignalMyRoomsResponse> {
    const url = this.BaseUrl + '/create-private';
    return  this.httpClient.post<SignalMyRoomsResponse>(url, request)
  }

  downloadFile(url: string):Observable<HttpResponse<Blob>>{
    return this.httpClient.get(url, {responseType: 'blob',observe:'response'});
  }

  // Empty response will be return so in that case we put any in response
  uploadFileAttachments(request: UploadChatAttachmentRequest): Observable<any> {
    const url = this.BaseUrl + '/sendAttachment';
    const formData = new FormData;
    formData.append('roomId', request.roomId)
    formData.append('formFile', request.formFile)
    formData.append('text', request.text)
    return this.httpClient.post<any>(url, formData)
  }

  getRoomMissingMessages(request: GetRoomMissingMessagesRequest): Observable<GetRoomMessagesResponse> {
    const url = this.BaseUrl + `/${request.roomId}/missing-messages`;
    return this.httpClient.post<GetRoomMessagesResponse>(url, request);
  }

  deleteChatRoom(roomId : string) : Observable<any>{
    return this.httpClient.delete<any>(`${this.BaseUrl}/${roomId}`)
  }

  reactOnMessageRequest(request: ReactOnMessageRequest) : Observable<any>{
    return this.httpClient.put(`${this.BaseUrl}/react-to-message`, request);
  }
}
